document.addEventListener('DOMContentLoaded', () => {
  // Delegate clicks on plus/minus buttons inside .bundle-parent
  document.body.addEventListener('click', async (e) => {
    const plusBtn = e.target.closest('.sj-js-qty__adjust--plus');
    const minusBtn = e.target.closest('.sj-js-qty__adjust--minus');
    const sj_qty_wrapper = e.target.closest('.sj-js-qty__wrapper');
    if (sj_qty_wrapper) {
        sj_qty_wrapper.classList.add('is-loading');
    }
    if (!plusBtn && !minusBtn) return;

    // Find bundle-parent container
    const bundleParent = plusBtn?.closest('.bundle-parent') || minusBtn?.closest('.bundle-parent');
    if (!bundleParent) return;

    const parentInput = bundleParent.querySelector('.js-qty__num');
    if (!parentInput) return;

    // Calculate new quantity
    let currentQty = parseInt(parentInput.value, 10) || 0;
    if (plusBtn) currentQty += 1;
    if (minusBtn) currentQty = Math.max(0, currentQty - 1);

    // Set new qty and trigger change event on input
    parentInput.value = currentQty;
    parentInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Listen for quantity changes on parent inputs inside .bundle-parent
  document.body.addEventListener('change', async (e) => {
    const input = e.target;
    if (!input.classList.contains('js-qty__num')) return;

    // Only act if inside bundle-parent
    const bundleProduct = input.closest('.bundle-product');
    if (!bundleProduct) return;

    const newQty = parseInt(input.value, 10);
    if (isNaN(newQty) || newQty < 0) return;

    // Get parent key
    const parentKey = bundleProduct.querySelector('.bundle-parent .cart__item')?.dataset.key;
    if (!parentKey) return;

    // Get all children keys
    const childrenKeys = Array.from(bundleProduct.querySelectorAll('.bundle-children .cart__item')).map(el => el.dataset.key);

    // Prepare updates for parent and children
    const updates = [{ id: parentKey, quantity: newQty }];
    childrenKeys.forEach(key => updates.push({ id: key, quantity: newQty }));

    try {
      // Update all items sequentially (avoid API flooding)
      for (const item of updates) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(item),
        });
      }
      // Reload page to reflect changes
      //location.reload();
      refreshCart();
      //document.dispatchEvent(new CustomEvent('cart:build'));
    } catch (err) {
      console.error('Error updating cart items:', err);
    }
  });
});
function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    
    // Force AOS refresh after a delay to ensure images are loaded
    setTimeout(() => {
        if (window.AOS) {
            AOS.refreshHard();
            document.querySelectorAll('.cart__image image-element[data-aos="image-fade-in"]').forEach(el => el.classList.add('aos-animate'));
        }
    }, 500);
}